var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._g({staticClass:"kk-arrow",style:(_vm.btnStyle)},_vm.$listeners),[_c('v-icon',{attrs:{"size":24}},[_vm._v("mdi-chevron-right")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }